var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart104-template',{attrs:{"board-ids":[938, 940],"data-type":_vm.dataType,"graph-id":104,"depth":_vm.depth,"date-field":"$.body.education_date","is-move-detail":false,"title":"안전·보건 교육 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }